module.exports = __webpack_public_path__ + "5cf9533118cbfc9717b9c5f3a681626d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/morgan_stanley.png
// module id = 1822
// module chunks = 0